import http from '@/axios/http'
/**
 * 获取终端列表
 * @param {*} data 
 * @returns 
 */
export function getCameraList(data) {
    return http({
        url: '/api/camera/list',
        method: 'post',
        data
    })
}

export function editCamera(data) {
    return http({
        url: '/api/camera/edit',
        method: 'post',
        data
    })
}

export function deleteCamera(data) {
    return http({
        url: '/api/camera/del',
        method: 'post',
        data
    })
}